module.exports = __webpack_public_path__ + "static/media/riverpod.0f7cf7fa.webp";